// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2U_9_","inputWrap":"Table_inputWrap__3Yvcd","col":"Table_col__32ZBW","bmiTooltip":"Table_bmiTooltip__2kf4H"};